import React, { FC } from 'react';
import { Steps } from 'antd';
import { Container, H4, Caption, Text } from '@erecruit/ui-kit';
import { ThemedLink, Authorize } from '@erecruit/modules';
import { Resources, AppPermissions } from '@erecruit/types';
import { Intl } from '@erecruit/core';
import CircleIcon from './CircleIcon';

const { FormattedMessage } = Intl;

type ShiftWidgetProps = {
  data: Resources.Shift;
};

type ShiftWidgetDescriptionProps = {
  isCandidateAssigned: boolean;
  candidateName?: string;
  matchId?: number;
};

const ShiftWidgetDescription: FC<ShiftWidgetDescriptionProps> = props => {
  if (props.isCandidateAssigned) {
    return (
      <Text align="center">
        <FormattedMessage
          id={messageIds.vms.shiftRecord.widgetAssignedCandidate}
        />{' '}
        <Authorize
          permission={`${AppPermissions.ViewMatches} & ${AppPermissions.ViewMatch}`}
        >
          {(isAuthorized: boolean) =>
            isAuthorized ? (
              <ThemedLink to={`/shifts/match/${props.matchId}`}>
                {props.candidateName}
              </ThemedLink>
            ) : (
              <Text inline={true}>{props.candidateName}</Text>
            )
          }
        </Authorize>
      </Text>
    );
  }

  return (
    <Caption align="center">
      <FormattedMessage id={messageIds.vms.shiftRecord.widgetNoCandidate} />
    </Caption>
  );
};

const ShiftWidget: FC<ShiftWidgetProps> = props => {
  const { data } = props;
  const candidateExists =
    data.candidate !== null && data.candidate !== undefined;

  return (
    <Container background="transparent" padding={[10, 0, 5, 0]}>
      <Steps.Step
        title={
          <H4 align="center" padding={[5, 0, 3, 0]}>
            <FormattedMessage id={messageIds.vms.shiftRecord.widgetShift} />{' '}
            {data.shiftStatus.name}
          </H4>
        }
        description={
          <ShiftWidgetDescription
            isCandidateAssigned={candidateExists}
            candidateName={data.candidate?.name}
            matchId={data.matchId}
          />
        }
        icon={
          <Text align="center">
            <CircleIcon
              isFilled={candidateExists}
              isCanceled={data.isCancelled}
              isClosed={data.isClosed}
            />
          </Text>
        }
      />
    </Container>
  );
};

export default ShiftWidget;
